import * as React from "react";

type sortPropsType = {
	sortName: string;
	sortValue: string;
};

const Sorter: React.FC<{
	setSorter: (value: string) => void;
	defaultSort: string;
	sortPropsVariant: string;
}> = ({ defaultSort, setSorter, sortPropsVariant }) => {
	const onChange = (evt: any) => {
		setSorter(evt.target.value);
	};

	const broadbandSortProps = [
		{
			sortName: "Recommended",
			sortValue: "recommended",
		},
		{
			sortName: "Price (High to Low)",
			sortValue: "price-high-low",
		},
		{
			sortName: "Price (Low to High)",
			sortValue: "price-low-high",
		},
		{
			sortName: "Speed (High to Low)",
			sortValue: "speed-high-low",
		},
		{
			sortName: "Speed (Low to High)",
			sortValue: "speed-low-high",
		},
	];

	const mobileSortProps = [
		{
			sortName: "Savely Recommended",
			sortValue: "savely_recommended",
		},
		{
			sortName: "Monthly Cost",
			sortValue: "monthly_cost",
		},
		{
			sortName: "Total Cost",
			sortValue: "total_cost",
		},
		{
			sortName: "Data",
			sortValue: "data",
		},
	];

	const articleSortProps = [
		{
			sortName: "Newest to Oldest",
			sortValue: "newest-to-oldest",
		},
		{
			sortName: "Oldest to Newest",
			sortValue: "oldest-to-newest",
		},
	];

	const selectedSortProps =
		sortPropsVariant === "broadband"
			? broadbandSortProps
			: sortPropsVariant === "mobile"
			? mobileSortProps
			: sortPropsVariant === "article"
			? articleSortProps
			: [];

	return (
		<>
			<label className="font-weight-500 pe-3">Sort by</label>
			<div className="select__container">
				<select
					className="select broadband-affiliate__sorter"
					onChange={onChange}
					defaultValue={defaultSort}
					id="BB-Comparison-Sorter"
				>
					{selectedSortProps.map((sortProp: sortPropsType, index: number) => {
						return (
							<option value={sortProp.sortValue} key={index}>
								{sortProp.sortName}
							</option>
						);
					})}
				</select>
			</div>
		</>
	);
};

export default Sorter;
